import(/* webpackMode: "eager" */ "C:\\Users\\u20cs\\Desktop\\weekrtLanding\\weekrt-landing-page\\app\\error.tsx");
